angular.module('jv.Dashboard.Factory', [])
.factory('jvDashboardFactory',['$timeout', 'jvDashboardAjaxService', '$rootScope',
    function($timeout, jvDashboardAjaxService,$rootScope) {
        var _dashboardConfig = {};
        var _userDashboard = {};
        var widgetInstanceMap = {};
        var widgetInstanceMapCopy = {};
        var newlyAddedWidgetsMap = {};
        var jvDashboardFactoryObject = {
            filterPostData: function(obj) {
                var filterKeysArray = ['sizeY','row','col','src','url','responseKey','queryParamName','responseType','class','title','newWidget','default', '', 'position', 'promptText', 'templates'];
                angular.forEach(filterKeysArray,function(keyValue, index){
                    //Removed check for obj[keyValue] as that gets evaluated to 0 for some cases.
                    delete obj[keyValue];
                });

                angular.forEach(obj.userValues, function(value, key) {
                    if (value.createdByCode && obj.userValues.length === 1) {
                        //delete obj.userValues;
                    }
                })
                if (angular.isDefined(obj.subWidgetSettingUserValues)) {
                    angular.forEach(obj.subWidgetSettingUserValues, function(value, index) {
                        if (value.createdByCode && obj.subWidgetSettingUserValues.length === 1) {
                            delete obj.subWidgetSettingUserValues;
                        } else {
                            value = jvDashboardFactoryObject.filterPostData(value);
                        }
                    });
                }
                return obj;
            },

            //Add new widget's id to newlyAddedWidgetsMap
            updateNewlyAddedWidgetsMap : function(widget){
                newlyAddedWidgetsMap[widget.widgetId] = true;
            },

            //Removes a newly added widget from the newlyAddedWidgetsMap
            removeNewlyAddedWidgetFromMap: function(widgetId){
                delete newlyAddedWidgetsMap[widgetId];
            },

            //compares against newlyAddedWidgetsMap to check if a widget is newly added
            isNewlyAddedWidget: function(widget){
                if(newlyAddedWidgetsMap[widget.widgetId]){
                    this.removeNewlyAddedWidgetFromMap(widget.widgetId);
                    return true;
                }
            },

            transformWidgetToGridsterObject: function(widgetObject,newWidget) {
                //Template for disabled/deleted templates
                var disabledWidgetTemplate = "dashboard/disabledWidget.html";

                var userWidget = {};
                angular.extend(userWidget,widgetObject);
                userWidget.settings = true;
                //making sure widgets height increases with the content
                userWidget.sizeY = widgetObject.widget.height;
                userWidget.row = widgetObject.widgetLocation.row;
                userWidget.col = widgetObject.widgetLocation.col;
                userWidget.src = widgetObject.widget.templateUrl;
                if(newWidget){
                    userWidget.newWidget = true;
                }
                if(widgetObject.widget.disabled || widgetObject.widget.deleted || widgetObject.unauthorized || widgetObject.decommissioned){
                    userWidget.src = disabledWidgetTemplate;
                    widgetObject.widget.refreshEnabled = false;
                }

                return userWidget;
            },

            //Transform the widets in a format that gridster accepts
            transformWidgetsToGridsterObject : function(userWidgets){
                var self = this;
                var _userWidgets = [];
                angular.forEach(userWidgets,function(widgetObject,key){
                    _userWidgets.push(self.transformWidgetToGridsterObject(widgetObject));
                });

                _userWidgets.sort(self.sortWidgetsArray);

                var column1Row = 0;
                var column2Row = 0;
                angular.forEach(_userWidgets, function(userWidget, key) {
                    if (userWidget.col === 0) {
                        userWidget.row = column1Row;
                        column1Row++;
                    } else if (userWidget.col === 6) {
                        userWidget.row = column2Row;
                        column2Row++;
                    }
                });

                return _userWidgets;

            },

            //sorts widget based on col and row
            sortWidgetsArray: function(a, b) {
                var aRow = a.widgetLocation.row;
                var bRow = b.widgetLocation.row;
                var aCol = a.widgetLocation.col;
                var bCol = b.widgetLocation.col;

                if (aRow === bRow){
                    return (aCol < bCol) ? -1 : (aCol > bCol) ? 1 : 0;
                } else {
                    return (aRow < bRow) ? -1 : 1;
                }
            },

            //Transform the widets in a format that backend accepts
            transformWidgetsFromGridsterObject : function(widgets){
                var modifiedUserWidgets = [];
                var postData = {};
                angular.forEach(widgets, function(widget,key){
                    widget.widgetLocation.row = widget.row;
                    widget.widgetLocation.col = widget.col;
                    modifiedUserWidgets.push(widget);
                });
                modifiedUserWidgets.sort(this.sortWidgetsArray);
                postData.userWidgets = angular.copy(modifiedUserWidgets);
                return postData.userWidgets.filter(this.filterPostData);
            },

            getUserDashboard : function() {
                return _userDashboard;
            },

            resolveWidgetTitle: function(widgets){
                angular.forEach(widgets,function(widgetObject,key){
                    if(widgetObject){
                        angular.forEach(widgetObject.userWidgetSettings.widgetSetting,function(settingsObject,key){
                            //works for all widget except links
                            if(settingsObject.settings.fieldType ==='Text' && settingsObject.settings.objectType === 'Title'){
                                if(settingsObject.userValues){
                                    widgetObject.title  = settingsObject.userValues[0].label;
                                }else{
                                    widgetObject.title = settingsObject.settings.defaultValues[0].label;
                                }

                            }
                        });
                    }
                });
            },

            widgetsAreUpdated: function(widget, originalWidget) {
                if (widget.col !== originalWidget.col
                    || widget.row !== originalWidget.row
                    || widget.sizeY !== originalWidget.sizeY
                    || !angular.equals(widget.userWidgetSettings, originalWidget.userWidgetSettings)
                    || !angular.equals(widget.widgetLocation, originalWidget.widgetLocation)) {
                    return true;
                } else {
                    return false;
                }
            },

            hasDashboardChanged: function(finalWidgets, originalWidgets) {
                var self = this;

                if (finalWidgets.length !== originalWidgets.length) {
                    return true;
                }

                var widgetsMap = {};
                var dashboardUpdated = false;

                //Create a widget map
                angular.forEach(finalWidgets, function(widget, key) {
                    widgetsMap[widget.widgetId] = widget;
                });

                angular.forEach(originalWidgets, function(originalWidget, key) {
                    if (!widgetsMap[originalWidget.widgetId] || (self.widgetsAreUpdated(widgetsMap[originalWidget.widgetId], originalWidget))) {
                        dashboardUpdated = true;
                    }
                });
                return dashboardUpdated;
            },

            saveUserDashboard: function(finalWidgets, originalWidgets, dashboardTitle) {
                var self = this;
                var deletedWidgets = [];
                var updatedWidgets = [];
                var addedWidgets = [];
                var widgetsMap = {};
                var widgets = angular.copy(finalWidgets);

                //Create a widget map
                angular.forEach(widgets, function(widget, key) {
                    widgetsMap[widget.widgetId] = widget;
                });

                //Loop through original widgets list to check if they are deleted/updated
                angular.forEach(originalWidgets, function(originalWidget, key) {
                    if (!widgetsMap[originalWidget.widgetId]) {
                        deletedWidgets.push(originalWidget.widgetId);
                    } else if (self.widgetsAreUpdated(widgetsMap[originalWidget.widgetId], originalWidget)) {
                        updatedWidgets.push(widgetsMap[originalWidget.widgetId]);
                        widgets.splice(widgets.indexOf(widgetsMap[originalWidget.widgetId]), 1);
                    } else if (!self.widgetsAreUpdated(widgetsMap[originalWidget.widgetId], originalWidget)) {
                        //Widgets are not updated. They dont need to be sent to the backend.
                        widgets.splice(widgets.indexOf(widgetsMap[originalWidget.widgetId]), 1);
                    }
                });

                //Remaining widgets need to be added.
                addedWidgets = widgets;
                if(addedWidgets.length){
                    //remove border property for newly added widgets
                    angular.forEach(finalWidgets,function(widget,key){
                        if(widget.newWidget){
                            delete widget.newWidget;
                        }
                    });
                }

                var filterSettings = function(widgets) {
                    angular.forEach(widgets, function(value, key) {
                        angular.forEach(value.userWidgetSettings.widgetSetting, function(value, key) {
                            delete value.settings;
                            if (value.subWidgetSettingUserValues) {
                                angular.forEach(value.subWidgetSettingUserValues, function(value, key) {
                                    delete value.settings;
                                    if (value.subWidgetSettingUserValues) {
                                        angular.forEach(value.subWidgetSettingUserValues, function(value, key) {
                                            delete value.settings;
                                        })
                                    }
                                });
                            }
                        })
                    });
                    return widgets;
                }

                //Rest of the widgets are
                if(dashboardTitle){
                    _userDashboard.userDashboardTitle = angular.copy(dashboardTitle);
                }
                var postDashboard = angular.copy(_userDashboard);
                delete postDashboard.userWidgets;
                if (addedWidgets.length) {
                    postDashboard.newWidgets = filterSettings(angular.copy(this.transformWidgetsFromGridsterObject(addedWidgets)));
                }
                if (updatedWidgets.length) {
                    postDashboard.updatedWidgets = filterSettings(angular.copy(this.transformWidgetsFromGridsterObject(updatedWidgets)));
                }
                if (deletedWidgets.length) {
                    postDashboard.deletedWidgetIds = angular.copy(deletedWidgets);
                }
                jvDashboardAjaxService.saveUserDashboard(postDashboard, function() {
                    $rootScope.$emit('DASHBOARD_UPDATED');
                });
            },

            setUserDashboard: function(userDashboard) {
                _userDashboard = userDashboard;
                $rootScope.$emit('DASHBOARD_UPDATED');
            },

            setWidgetInstanceForWidget: function(widgetType, instance){
                widgetInstanceMap[widgetType] = instance;
            },

            updateWidgetInstance: function(widgetType, increment){
                if (increment) {
                    widgetInstanceMap[widgetType] += 1;
                } else if (widgetInstanceMap[widgetType]) {
                    widgetInstanceMap[widgetType] -= 1;
                }
            },

            getWidgetInstance: function(widgetType) {
                return widgetInstanceMap[widgetType];
            },

            resetWidgetInstanceMap: function(){
                widgetInstanceMap = angular.copy(widgetInstanceMapCopy);
                $rootScope.$emit('DASHBOARD_WIDGET_INSTANCE_MAP_RESET',widgetInstanceMap);
            },

            showSettingsModal: function(widget){
                $scope.editSettings(widget);
            },

            getWidgetInstanceMap: function() {
                widgetInstanceMapCopy = angular.copy(widgetInstanceMap);
                return widgetInstanceMap;
            },

            setWidgetInstanceMap: function(){
                angular.forEach(_dashboardObject.dashboard.userWidgets,function(widget,key){
                    if(widgetInstanceMap[widget.mainType] ){
                        widgetInstanceMap[widget.mainType] += 1;
                    }else{
                        widgetInstanceMap[widget.mainType] = 1;
                    }
                });
                return widgetInstanceMap;
            },

            getDashboardConfig : function() {
                return _dashboardConfig;
            },

            setDashboardConfig : function(dashboardConfig) {
                _dashboardConfig = angular.copy(dashboardConfig);
                $rootScope.$emit('DASHBOARD_CONFIG_UPDATED');
            },

            setUserDashboardTitle: function(userDashboardTitle){
                _dashboardConfig.userDashboardTitle = angular.copy(userDashboardTitle);
            },
            resetDashboardWidgets: function(widgets){
                _dashboardConfig.widgets = angular.copy(widgets);
            },

            saveDashboardConfigDrag: function(val) {
                _dashboardConfig.draggable.enabled = val;
                $rootScope.$emit('DASHBOARD_CONFIG_UPDATED');
            },

            getWidgets: function() {
                return _dashboardConfig.widgets;
            },

            addWidgetToLayout: function(userWidget){
                _dashboardConfig.widgets.unshift(this.transformWidgetToGridsterObject(userWidget,true));
                $rootScope.$emit('DASHBOARD_CONFIG_UPDATED');
            },

            removeWidgetFromLayout: function(userWidget) {
                var index  = _dashboardConfig.widgets.indexOf(userWidget);
                _dashboardConfig.widgets.splice(index, 1);
            },

            addWidget: function(widgetType) {
                var self = this;
                var data = {
                    'widgetType': widgetType
                };
                jvDashboardAjaxService.addWidget(data, function(response) {
                    if (response && response.userWidget) {
                        $rootScope.$emit('DASHBOARD_SHOW_SETTINGS_MODAL',response.userWidget);
                    }
                });
            },

            deleteWidget: function(userWidget) {
                this.removeWidgetFromLayout(userWidget);
            }
        };
        return jvDashboardFactoryObject;
    }
]);
